// automatically generated by the FlatBuffers compiler, do not modify

export enum LoadWeigherStatus {
  Light = 0,
  Normal = 1,
  Dispatch = 2,
  Heavy = 3,
  Overload = 4
}
